import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fmtPrice = (n) =>
  new Intl.NumberFormat("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);

export const DEFAULT_HERO_BANNER =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_soap-market-9/artifacts/urgvo6d6_IMG-20260905-WA0008.jpg";

export const getSettings = async () => {
  const { data } = await axios.get(`${API}/settings`);
  return data;
};

export const getProducts = async () => {
  const { data } = await axios.get(`${API}/products`);
  return data;
};

export const getProduct = async (slug) => {
  const { data } = await axios.get(`${API}/products/${slug}`);
  return data;
};

export const getReviews = async (slug) => {
  const { data } = await axios.get(`${API}/products/${slug}/reviews`);
  return data;
};

export const addReview = async (slug, payload) => {
  const { data } = await axios.post(`${API}/products/${slug}/reviews`, payload);
  return data;
};

export const createOrder = async (payload) => {
  const { data } = await axios.post(`${API}/orders`, payload);
  return data;
};

export const PHONE = "0755664665";
export const PHONE_TEL = "tel:0755664665";
